import {
    CREATE_SJFSUPPORTTICKETS,
    RETRIEVE_SJFSUPPORTTICKETS,
    RETRIEVESINGLE_SJFSUPPORTTICKETS,
    UPDATE_SJFSUPPORTTICKETS,
    DELETE_SJFSUPPORTTICKETS,
  } from "../actions/type";
  const initialState = [];
  function SJFSupportTicketsReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case CREATE_SJFSUPPORTTICKETS:
        return {data: state.data, payload};
      case RETRIEVE_SJFSUPPORTTICKETS:
        // console.log(payload)
        state = (payload.error == 1)?initialState:payload;
        return {data: state, payload};
      case RETRIEVESINGLE_SJFSUPPORTTICKETS:
        state = (payload.error == 1)?initialState:payload;
        return {data: state.data, payload};
      case UPDATE_SJFSUPPORTTICKETS:
        return {data: state.data, payload};
      case DELETE_SJFSUPPORTTICKETS:
        return {data: state.data, payload};
      default:
        return state;
    }
  };
  export {SJFSupportTicketsReducer};